import { useEffect, useState } from "react";

const Logo = () => (
  <div className="flex items-center gap-2.5" data-testid="navbar-logo">
    <div className="relative h-7 w-7">
      <div className="absolute inset-0 rounded-md bg-gradient-to-br from-indigo-500 to-violet-600" />
      <div className="absolute inset-[3px] rounded-[5px] bg-[#050505] flex items-center justify-center">
        <div className="h-[2px] w-3 bg-indigo-400" />
      </div>
      <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 h-[2px] w-5 bg-violet-500/70 blur-[2px]" />
    </div>
    <div className="flex items-center gap-2">
      <span className="font-display text-[17px] font-semibold tracking-tight text-white">
        Equal
      </span>
      <span className="hidden sm:inline-flex items-center rounded-full border border-white/10 bg-white/[0.03] px-2 py-0.5 font-mono text-[9.5px] uppercase tracking-[0.2em] text-zinc-400">
        EqualLayer
      </span>
    </div>
  </div>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/70 border-b border-white/[0.06]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="inline-flex" data-testid="navbar-home-link">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8 font-body text-sm text-zinc-400">
          <a href="#problem" className="hover:text-white transition-colors" data-testid="nav-problem">Problem</a>
          <a href="#solution" className="hover:text-white transition-colors" data-testid="nav-solution">Solution</a>
          <a href="#how" className="hover:text-white transition-colors" data-testid="nav-how">How it works</a>
          <a href="#accessibility" className="hover:text-white transition-colors" data-testid="nav-accessibility">Accessibility</a>
          <a href="#vision" className="hover:text-white transition-colors" data-testid="nav-vision">Vision</a>
        </nav>

        <a
          href="#waitlist"
          data-testid="navbar-cta"
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] hover:bg-white/[0.07] hover:border-indigo-500/40 px-4 py-2 text-sm font-medium text-white transition-all"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-indigo-400 shadow-[0_0_10px_rgba(99,102,241,0.9)]" />
          Join Early Access
        </a>
      </div>
    </header>
  );
};

export default Navbar;
